import { mapRawSurveyListItemFromApiModel } from './surveyListItemDataMapper';

export const mapSurveyListFromApiModel = response => {
  const {
    data,
    meta: { count },
    included,
  } = response;

  const surveys = data.map(surveyItem =>
    mapRawSurveyListItemFromApiModel(surveyItem, included),
  );

  return {
    itemList: surveys,
    totalCount: count,
  };
};
